<template>
  <b-modal
    scrollable
    size="xl"
    id="result_detail_modal"
    ref="result_detail_modal"
    ok-only
    ok-title="Close"
    @hide="handleModalClose"
  >
    <div v-if="result">
      <span v-if="result.eligible_countries_ss" class="float-right mr-3 ml-3">
        <span class="eligibility-label mr-2">Eligibility</span>
        <b-badge
          variant="warning"
          class="float-right mr-1"
          v-for="(x, i) in result.eligible_countries_ss.slice().reverse()"
          :key="'ec' + i"
          v-b-popover.hover.top="{
            title: 'Eligible countries',
            content:
              '<b>M:</b> Member states<br><b>E:</b> EEA countries<br><b>A:</b> Associated countries<br><b>S:</b> Selected countries<br><b>T:</b> Third countries<br><br><b>Be aware: </b>Information about the eligibility of associated and third countries is determined by rule-based techniques on calls from 2021 onwards and may be inaccurate.<br><br> Please review the <b>Conditions</b> for certainty.',
            html: true,
          }"
        >
          {{ x.charAt(0) }}
        </b-badge>
      </span>

      <h2 v-if="result.sem_title">
        <b-badge variant="success" class="mr-2" v-if="topicVisited"
          >Visited</b-badge
        >

        <!--
        <b-badge variant="info" class="mr-2" v-if="result.action_statuses && result.action_statuses.length > 0">
        {{result.action_statuses[result.action_statuses.length-1]}}
        -->
        <b-badge variant="info" class="mr-2" v-if="result.topic_status_s">
          {{ result.topic_status_s }}
        </b-badge>

        {{ result.sem_title }}

        <a
          v-on:click.prevent="
            openGraph(result.sem_encoded_id, result.sem_title)
          "
          href="#"
          ><b-icon icon="diagram-2" font-scale="2" variant="secondary"></b-icon
        ></a>
      </h2>
      <h2 v-else>
        {{ result.sem_url }}
        <a
          v-on:click.prevent="
            openGraph(result.sem_encoded_id, result.sem_title)
          "
          href="#"
          ><b-icon icon="diagram-2" font-scale="2" variant="secondary"></b-icon
        ></a>
      </h2>

      <b-tabs card v-model="tabIndex" class="resultdetailtab">
        <ResultTopic
          v-if="result.sem_record_type == 'topic'"
          v-bind:result="result"
        ></ResultTopic>

        <b-tab v-if="result.conditions" title="Conditions">
          <b-card-text v-html="result.conditions"></b-card-text>
        </b-tab>

        <b-tab v-if="result.destinationDetails" title="Destination Details">
          <b-card-text v-html="result.destinationDetails"></b-card-text>
        </b-tab>

        <b-tab v-if="result.supportInfo" title="Support Info">
          <b-card-text v-html="result.supportInfo"></b-card-text>
        </b-tab>

        <CallDetail
          v-if="result.callDetailsJSONItem"
          v-bind:json="result.callDetailsJSONItem"
        >
        </CallDetail>

        <ExtractedInformation v-bind:result="result"></ExtractedInformation>
        <MoreLikeThis
          v-bind:url="result.sem_actions.mlt.sem_url"
        ></MoreLikeThis>
      </b-tabs>
    </div>

    <ListLoader
      v-if="!result || result == ''"
      :speed="2"
      :animate="true"
    ></ListLoader>
  </b-modal>
</template>

<script>
import { ListLoader } from "vue-content-loader";
import MoreLikeThis from "./MoreLikeThis";
import ResultTopic from "./ResultTopic";
import CallDetail from "./CallDetail";
import ExtractedInformation from "./ExtractedInformation";

export default {
  name: "ResultDetail",
  props: ["id"],
  components: {
    MoreLikeThis,
    ResultTopic,
    ExtractedInformation,
    ListLoader,
    CallDetail,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  created() {
    if (
      this.id &&
      (this.selectedResult == null ||
        this.selectedResult == "" ||
        this.selectedResult.id != this.id)
    ) {
      this.$store.dispatch("fetchSelectedResult", this.id);
      this.$store.commit("updateVisitedTopics", this.id);
    } else {
      this.error = "No result id specified.";
    }
  },
  mounted() {
    if (this.id) {
      this.$refs.result_detail_modal.show();
    }
  },
  methods: {
    handleModalClose() {
      window.history.state != null
        ? this.$router.go(-1)
        : this.$router.push("/");
    },
    openGraph(nodeId, nodeTitle) {
      this.$router.push({
        name: "visualization",
        query: { id: nodeId },
        params: { nodeTitle: nodeTitle },
      });
    },
  },
  computed: {
    result() {
      return this.$store.state.selectedResult
        ? this.$store.state.selectedResult
        : null;
    },
    response() {
      return this.$store.state.response
        ? this.$store.state.response.response
        : null;
    },
    topicVisited() {
      if (this.$store.state.visitedTopics) {
        return (
          this.$store.state.visitedTopics.indexOf(this.result.sem_encoded_id) >
          -1
        );
      } else {
        return false;
      }
    },
  },
  watch: {
    id: function(newId) {
      this.$store.dispatch("fetchSelectedResult", newId);
      this.$store.commit("updateVisitedTopics", newId);
      this.tabIndex = 0;
    },
  },
};
</script>

<style>
.resultdetailtab li {
  margin-right: 5px;
}
.eligibility-label {
  font-size: 75%;
  font-weight: 500;
  vertical-align: super;
}
</style>
